const state = {
  menuIsOpen: true,
  pageTitle: '',
  paymentState: "",
  isShowKyc: false,
};

// getters
const getters = {
  menuIsOpen: (state, getters, root) => {
    return state.menuIsOpen;
  },
  pageTitle: (state, getters, root) => {
    return state.pageTitle;
  },
  paymentState: (state, getters, root) => {
    return state.paymentState
  },
  isShowKyc: s => s.isShowKyc
};

// actions
const actions = {
  toggleMenu({ commit, state, dispatch }, data) {
    commit('toggleMenu', data);
  },
  setPageTitle({ commit, state, dispatch }, title) {
    commit('setPageTitle', title);
  },
  setPaymentState({ commit, state, dispatch }, data) {
    commit('setPaymentState', data);
  },
};

// mutations
const mutations = {
  toggleMenu(state, flag) {
    state.menuIsOpen = flag;
  },
  setPageTitle(state, title) {
    state.pageTitle = title;
  },
  setPaymentState(state, statename) {
    state.paymentState = statename;
  },
  setShowKyc(state, v) {
    state.isShowKyc = v;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js